<template>
    <section class="city-contact">
        <h3 class="city-name">
            <i class="icon icon-s-location" v-if="city === positionCity || city + '市' === positionCity"></i>
            <span v-text="city"></span>
            <span v-if="city === positionCity || city + '市' === positionCity">-当前城市</span>
        </h3>
        <div class="contact-people-list">
            <div class="contact-people" v-if="city === '上海' && has2500">
                <a class="contact-tel-wrap flexBox" href="tel:021-6908-2500">
                    <img class="contact-avator" src="../../static/images/2500_avator.png">
                    <div class="contact-info flexItem">
                        <p class="account">2500服务台</p>
                        <p class="location">Shanghai</p>
                    </div>
                    <i class="icon icon-telephone"></i>
                </a>
            </div>
            <div class="contact-people" v-for="list in lists">
                <a class="contact-tel-wrap flexBox" :href="'tel:' + list.Mobile">
                    <img class="contact-avator" :src="list.HeadImg" onerror="this.onerror=null;this.src='../../static/images/default.png'">
                    <div class="contact-info flexItem">
                        <p class="account" v-text="list.Name"></p>
                        <p class="remark" v-text="list.Remarks"></p>
                        <p class="location" v-text="list.Location"></p>
                    </div>
                    <i class="icon icon-telephone"></i>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'cityContactList',
        data () {
            return {
                positionCity: localStorage.cityName
            }
        },
        props: {
            lists: {},
            city: {},
            has2500: {}
        }
    }
</script>

<style lang="scss" scoped>
    .city-contact {
        padding: j(40) j(40) 0 j(30);
        background: #ffffff;
        border-radius: j(4);
        .city-name {
            margin-bottom: j(25);
            // color: #666666;
            color: #696D7F;
            font-size: j(28);
            font-weight: normal;
        }
        .contact-people-list {
            .contact-people {
                padding: j(40) 0;
                position: relative;
                @extend %bb1;
                .contact-avator {
                    width: j(120);
                    height: j(120);
                    margin-right: j(28);
                    border-radius: 50%;
                }
                .account {
                    margin-bottom: j(20);
                    // color: #333333;
                    color: #363C54;
                    font-size: j(30);
                }
                .remark, .location {
                    // color: #999999;
                    color: #9B9DA9;
                    font-size: j(24);
                }
                .icon-telephone {
                    font-size: j(60);
                }
            }
            .contact-people:last-child:after {
                background: transparent;
            }
        }
    }
    .city-contact + .city-contact {
        margin-top: j(30);
    }
</style>


// WEBPACK FOOTER //
// src/components/contactList.vue